import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeContext, THEMES } from "./context/ThemeContext";
import { useState, useEffect } from "react";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Home from "./pages/Home";
import AddBook from "./pages/AddBook";
import BookDetail from "./pages/BookDetail";
import BookReport from "./pages/BookReport";
import Scaffolding from "./pages/Scaffolding";
import ParentDashboard from "./pages/ParentDashboard";
import ChildDetail from "./pages/ChildDetail";
import ParentBookView from "./pages/ParentBookView";
import Quiz from "./pages/Quiz";
import EditBook from "./pages/EditBook";
import Settings from "./pages/Settings";
import SightWordQuiz from "./pages/SightWordQuiz";

function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/login" />;
}

function ParentRoute({ children }) {
  const { currentUser, userProfile } = useAuth();
  if (!currentUser) return <Navigate to="/login" />;
  if (userProfile?.role !== "parent") return <Navigate to="/" />;
  return children;
}
function ThemeProvider({ children }) {
  const { userProfile } = useAuth();
  const [theme, setTheme] = useState(THEMES["neutral-girl"]);

  useEffect(() => {
    if (!userProfile) return;
    if (userProfile.role !== "child") return;
    const matched = THEMES[userProfile.theme] || THEMES["neutral-girl"];
    setTheme(matched);
  }, [userProfile]);

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
}
function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
      <Route path="/add-book" element={<PrivateRoute><AddBook /></PrivateRoute>} />
      <Route path="/book/:id" element={<PrivateRoute><BookDetail /></PrivateRoute>} />
      <Route path="/book/:id/edit" element={<PrivateRoute><EditBook /></PrivateRoute>} />
      <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
      <Route path="/book/:id/scaffolding" element={<PrivateRoute><Scaffolding /></PrivateRoute>} />
      <Route path="/book/:id/report/:reportId" element={<PrivateRoute><BookReport /></PrivateRoute>} />
      <Route path="/book/:id/quiz/:quizId" element={<PrivateRoute><Quiz /></PrivateRoute>} />
      <Route path="/sight-word-quiz" element={<PrivateRoute><SightWordQuiz /></PrivateRoute>} />
      <Route path="/parent" element={<ParentRoute><ParentDashboard /></ParentRoute>} />
      <Route path="/parent/child/:childId" element={<ParentRoute><ChildDetail /></ParentRoute>} />
      <Route path="/parent/child/:childId/book/:bookId" element={<ParentRoute><ParentBookView /></ParentRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <AppRoutes />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}